
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
        display:block;
}

img {
        height:auto;
        width:100%;
}

:host(:not([site='BH'])) .quote-testimonial {
        box-sizing:border-box;
}

:host(:not([site='BH'])) .quote-testimonial {
        padding-top:2rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial {
                padding-top:3rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial:not(.quote-testimonial--full-width) {
        margin-left:auto;
        margin-right:auto;
}

:host(:not([site='BH'])) .quote-testimonial:not(.quote-testimonial--full-width) {
        max-width:1024px;
}

:host(:not([site='BH'])) .quote-testimonial__title {
        font-family:var(--ff-body);
}

:host(:not([site='BH'])) .quote-testimonial__eyebrow{
  }

:host(:not([site='BH'])) .quote-testimonial__title {
        margin-bottom:0.5rem;
}

:host(:not([site='BH'])) .quote-testimonial__title {
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
}

:host(:not([site='BH'])) .quote-testimonial__title {
        text-transform:uppercase;
}

:host(:not([site='BH'])) .quote-testimonial__title {
        color:var(--primary-blue);
}

:host(:not([site='BH'])) .quote-testimonial__content-section {
        flex-direction:column;
}

:host(:not([site='BH'])) .quote-testimonial__content-section {
        justify-content:center;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial__content-section {
                display:flex;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial__content-section {
                height:100%;
        }
}

:host(:not([site='BH'])) .quote-testimonial__attribution {
        margin-bottom:0.5rem;
}

:host(:not([site='BH'])) .quote-testimonial__attribution {
        display:inline-flex;
}

:host(:not([site='BH'])) .quote-testimonial__attribution {
        font-weight:var(--fw-bold);
}

:host(:not([site='BH'])) .quote-testimonial__attribution {
        color:var(--neutral-gray-1);
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        margin-top:auto;
        margin-bottom:auto;
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        margin-right:0.25rem;
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        margin-left:0px;
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        height:1px;
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        width:1.25rem;
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        border-style:none;
}

:host(:not([site='BH'])) .quote-testimonial__attribution hr {
        background-color:var(--neutral-gray-2);
}

:host(:not([site='BH'])) .quote-testimonial__cta {
        margin-left:1.25rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial__cta {
                margin-left:2.5rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__eyebrow {
        position:absolute;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__eyebrow {
        top:-2.5rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__eyebrow {
        left:1.5rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__eyebrow {
                top:-3rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__eyebrow {
                left:3.5rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        position:relative;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        margin-bottom:2rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner{
    }

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        border-top-right-radius:1rem;
        border-bottom-right-radius:1rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        border-width:1px;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        border-style:solid;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        border-color:var(--primary-blue);
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        background-color:var(--neutral-white);
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
        align-items:center;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
                display:flex;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
                flex-direction:row;
        }
}

@media (min-width: 1024px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner {
                border-radius:1rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before{
        content:'';
      }

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        position:absolute;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        left:1rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        top:-1px;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        display:block;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        height:1px;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        width:6rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
        background-color:var(--neutral-white);
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
                left:2.5rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__inner::before {
                width:8.25rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content-section {
        padding-left:1.25rem;
        padding-right:1.25rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content-section {
        padding-top:2.5rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content-section {
        padding-bottom:1.25rem;
}

@media (min-width: 640px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content-section {
                padding-top:4rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content-section {
                padding-left:2.5rem;
                padding-right:2.5rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content-section {
                padding-bottom:2rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
        margin-bottom:1.5rem;
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
        font-family:var(--ff-display);
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
        font-size:var(--fs-2xl);
        line-height:var(--lh-2xl);
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
        font-weight:var(--fw-semibold);
}

:host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
        color:var(--primary-blue);
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
                margin-bottom:2rem;
        }
}

@media (min-width: 1024px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
                margin-bottom:2.5rem;
        }
}

@media (min-width: 1024px) {

        :host(:not([site='BH'])) .quote-testimonial--default .quote-testimonial__content {
                font-size:var(--fs-3xl);
                line-height:var(--lh-3xl);
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image {
                padding-right:2rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__inner {
        margin-bottom:8rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__inner {
                margin-bottom:2.5rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__inner {
                padding-right:18rem;
        }
}

@media (min-width: 1024px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__inner {
                padding-right:22rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        position:absolute;
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        flex-shrink:0;
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        overflow:hidden;
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        border-radius:0.75rem;
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        bottom:-7rem;
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        right:-1rem;
}

:host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
        width:8rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
                bottom:-4rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
                right:-2rem;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image {
                width:20rem;
        }
}

@media (min-width: 1024px){
      :host(:not([site='BH'])) .quote-testimonial--has-image .quote-testimonial__image{
        width:24rem;
      }
    }

:host(:not([site='BH'])) .quote-testimonial--plain {
        margin-left:2.5rem;
}

:host(:not([site='BH'])) .quote-testimonial--plain {
        padding-top:1rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain {
                margin-left:0px;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain {
                padding-top:3rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__eyebrow {
        position:absolute;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__eyebrow {
        top:-1rem;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__eyebrow {
        left:-2.5rem;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__eyebrow {
                left:-70px;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__eyebrow {
                top:-1.5rem;
        }
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        position:relative;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
                margin-left:70px;
        }
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner{
    }

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-width:1px;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-top-width:1px;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-left-width:0px;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-bottom-width:0px;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-right-width:0px;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-style:solid;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        border-color:var(--primary-blue);
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
        align-items:center;
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
                display:flex;
        }
}

@media (min-width: 768px) {

        :host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__inner {
                flex-direction:row;
        }
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__content-section {
        padding-top:1rem;
}

:host(:not([site='BH'])) .quote-testimonial--plain .quote-testimonial__content {
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
}

:host([site='BH']) .quote-testimonial__inner {
        font-family:var(--bh-ff-display);
}

:host([site='BH']) .quote-testimonial__inner {
        font-size:var(--fs-xl);
        line-height:var(--lh-xl);
}

:host([site='BH']) .quote-testimonial__inner .quote-testimonial__image {
        overflow:hidden;
}

:host([site='BH']) .quote-testimonial__inner .quote-testimonial__eyebrow {
        padding-bottom:1rem;
}

:host([site='BH']) .quote-testimonial__inner .quote-testimonial__attribution {
        padding-top:1rem;
}

:host([site='BH']) .quote-testimonial__inner .quote-testimonial__attribution {
        font-family:var(--bh-ff-body);
}

:host([site='BH']) .quote-testimonial__inner .quote-testimonial__attribution {
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);
}

:host([site='BH']) .quote-testimonial__inner .quote-testimonial__attribution hr {
        display:none;
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        display:flex;
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        flex-direction:column-reverse;
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        flex-wrap:wrap;
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        overflow:hidden;
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        border-radius:0.75rem;
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        background-color:var(--bh-brand-primary-default);
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
        color:var(--bh-neutral-white);
}

:host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__content-section {
        padding:1rem;
}

@media (min-width: 1024px){
      :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
                flex-direction:row;
        }
      :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner {
                font-size:var(--fs-2xl);
                line-height:var(--lh-2xl);
        }

        :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__eyebrow {
                padding-bottom:1.5rem;
        }

        :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__attribution {
                padding-top:1.5rem;
        }

        :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__attribution {
                font-size:var(--fs-xl);
                line-height:var(--lh-xl);
        }

        :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__content-section, :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__image {
                flex-grow:1;
        }

        :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__content-section, :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__image {
                flex-basis:50%;
        }

        :host([site='BH']) .quote-testimonial--default .quote-testimonial__inner .quote-testimonial__content-section {
                padding:4rem;
        }
    }

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        border-width:0px;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        border-top-width:2px;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        border-bottom-width:2px;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        border-style:solid;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        border-color:var(--bh-brand-primary-default);
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        padding-left:1rem;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        padding-right:1rem;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        padding-top:3rem;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
        padding-bottom:3rem;
}

:host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner .quote-testimonial__eyebrow {
        color:var(--bh-brand-primary-default);
}

@media (min-width: 1024px){
    :host([site='BH']) .quote-testimonial--plain {
                margin-left:auto;
                margin-right:auto;
        }
    :host([site='BH']) .quote-testimonial--plain {
                width:66.666667%;
        }
      :host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
                padding-top:4rem;
        }
      :host([site='BH']) .quote-testimonial--plain .quote-testimonial__inner {
                padding-bottom:4rem;
        }
  }
`;